module.exports = __webpack_public_path__ + "static/media/2 (38).4d5ce290.jpg";